import React, { FunctionComponent } from 'react';

import { Link as LinkType } from '@gojob/cms';
import Flex, { FlexProps } from '@gojob/ui-bits/Flex';

import Button from '../../Buttons/Button';

export interface LinkProps extends FlexProps<'div'>, LinkType {}

const Link: FunctionComponent<LinkProps> = (props) => {
  const { internalRef, href, id, text, icon, ...flexProps } = props;

  return (
    <Flex alignItems="center" {...flexProps}>
      <Button
        id={id}
        css={{ width: '100%', justifyContent: 'flex-start' }}
        icon={icon}
        href={href}
        internalRef={internalRef}
        variant="text"
      >
        {text}
      </Button>
    </Flex>
  );
};

export default Link;
